export const styles = (theme) => ({
  loader: {
    textAlign: 'center',
    width: 'auto',
    height: '600px',
    marginTop: '150px',
  },
});